import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { getInboxes, getCurrentInbox, getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import selectInbox from '../../unified-inbox/actions/selectInbox';
import SearchAndFilterModeButton from '../../thread-search-and-filtering/components/SearchAndFilterModeButton';
import InboxSelect from '../../unified-inbox/components/InboxSelect';
import { getShowAgentStatus } from '../../agentStatus/selectors/getShowAgentStatus';
import { getIsChatSetup } from '../../verify-install/selectors/getIsChatSetup';
import OutsideBusinessHours from '../../agentStatus/components/OutsideBusinessHours';
import { useCallingChannelInstances } from 'channel-settings/calling/public/hooks/useCallingChannelInstances';
import { AgentStatusContainer } from '../../agentStatus/containers/AgentStatusContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavSidebarHeader = () => {
  const dispatch = useDispatch();
  const currentInbox = useSelector(getCurrentInbox);
  const currentInboxId = useSelector(getCurrentInboxId);
  const inboxes = useSelector(getInboxes);
  const isChatSetup = useSelector(getIsChatSetup);
  const showAgentStatus = useSelector(getShowAgentStatus);
  const {
    data
  } = useCallingChannelInstances();
  const onInboxSelected = useCallback(inbox => {
    dispatch(selectInbox(inbox));
  }, [dispatch]);
  const isCallingConnectedToInbox = useMemo(() => {
    if (data && data.results) {
      return data.results.find(channelInstance => channelInstance.inboxId === currentInboxId);
    }
    return false;
  }, [currentInboxId, data]);
  const shouldShowAvailabilityToggle = useMemo(() => {
    return showAgentStatus || isCallingConnectedToInbox;
  }, [isCallingConnectedToInbox, showAgentStatus]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    inlineSize: "100%",
    paddingBlockStart: "100",
    paddingBlockEnd: "300",
    paddingInline: "200",
    borderBlockEndColor: "border-core-subtle",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      inlineSize: "100%",
      paddingInlineStart: "600",
      gap: "100",
      children: [/*#__PURE__*/_jsx(View, {
        flex: "1",
        minInlineSize: "0",
        children: currentInbox ? /*#__PURE__*/_jsx(InboxSelect, {
          onInboxSelect: onInboxSelected,
          inboxes: inboxes,
          currentInbox: currentInbox
        }) : null
      }), /*#__PURE__*/_jsx(View, {
        flexShrink: "0",
        children: /*#__PURE__*/_jsx(SearchAndFilterModeButton, {})
      })]
    }), isChatSetup && /*#__PURE__*/_jsx(OutsideBusinessHours, {}), shouldShowAvailabilityToggle && /*#__PURE__*/_jsx(AgentStatusContainer, {})]
  });
};
NavSidebarHeader.displayName = 'NavSidebarHeader';
export default NavSidebarHeader;